import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "d-flex text-b_grey-50",
  style: {"flex-grow":"0"}
}
const _hoisted_2 = { style: {"font-size":"17px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "AI VERGABE", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "webEdition", -1)
const _hoisted_6 = {
  class: "d-flex",
  style: {"flex-grow":"1"}
}
const _hoisted_7 = {
  class: "d-flex",
  style: {"flex-grow":"0","align-items":"center","color":"white"}
}
const _hoisted_8 = {
  class: "d-flex",
  style: {"column-gap":"12px","position":"relative","--evo-header-menu-top":"calc(100% + 4px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_evonum_spacer = _resolveComponent("evonum-spacer")!
  const _component_the_header_authority_menu = _resolveComponent("the-header-authority-menu")!
  const _component_the_header_user_menu = _resolveComponent("the-header-user-menu")!
  const _component_the_progress_bar = _resolveComponent("the-progress-bar")!
  const _component_simulation = _resolveComponent("simulation")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    flat: "",
    height: _ctx.isLowHeight ? 44 : 72,
    class: "bg-blue-700 px-4",
    style: {"position":"relative","overflow":"visible"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "left", {}, () => [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isExtraSmall)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_3, "AI VM"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createTextVNode("MANAGER "),
                  _hoisted_5
                ], 64))
          ])
        ])
      ]),
      _createVNode(_component_evonum_spacer),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "center")
      ]),
      _createVNode(_component_evonum_spacer),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "right", {}, () => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_the_header_authority_menu),
            _createVNode(_component_the_header_user_menu)
          ])
        ])
      ]),
      _createVNode(_component_the_progress_bar, { "data-cy": "the-header-progress-bar" }),
      (!_ctx.noSimulation)
        ? (_openBlock(), _createBlock(_component_simulation, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["height"]))
}